// extracted by mini-css-extract-plugin
export default {"HeaderLevel4":"HeaderLevel4__HeaderLevel4___V0twQ","centered":"HeaderLevel4__centered___et7K_"};